import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../../../assets/img/icons/left-arrow.svg'
import _imports_1 from '../../../assets/img/icons/right-arrow.svg'


const _hoisted_1 = { class: "category-wrap mt-30" }
const _hoisted_2 = { class: "category-slider" }
const _hoisted_3 = { class: "ctegory-card" }
const _hoisted_4 = { class: "cat-img" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "cat-info d-flex justify-content-between align-items-center" }
const _hoisted_7 = { class: "fs-18" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_swiper, {
        spaceBetween: 15,
        slidesPerView: 1,
        grabCursor: true,
        preventClicks: true,
        loop: true,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        },
        navigation: {
          nextEl: '.category-prev',
          prevEl: '.category-next',
        },
        breakpoints: {
          0: {
            slidesPerView: 1,
          },
          768: {
            slidesPerView: 2,
          },
          992: {
            slidesPerView: 4,
          },
          1200: {
            slidesPerView: 5,
          },
          1400: {
            slidesPerView: 6,
          },
          1600: {
            slidesPerView: 7,
          },
        },
        modules: _ctx.modules,
        class: "category-slider"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categorys, (category) => {
            return (_openBlock(), _createBlock(_component_swiper_slide, {
              key: category.id
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("img", {
                      src: category.image,
                      alt: "Image"
                    }, null, 8, _hoisted_5)
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("h6", _hoisted_7, [
                      _createVNode(_component_router_link, { to: "/shop-details" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(category.title), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _createElementVNode("span", null, "(" + _toDisplayString(category.items) + " Items)", 1)
                  ])
                ])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }, 8, ["modules"])
    ]),
    _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"slider-btn\" data-v-052d6ad5><div class=\"category-prev\" data-v-052d6ad5><img src=\"" + _imports_0 + "\" alt=\"Image\" data-v-052d6ad5></div><div class=\"category-next\" data-v-052d6ad5><img src=\"" + _imports_1 + "\" alt=\"Image\" data-v-052d6ad5></div></div>", 1))
  ]))
}